export default __webpack_public_path__ + "static/media/startLocation.11277935.svg";